import { Fragment } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import CreateFilingForm from "../../../components/forms/CreateFilingForm";
import ConfirmationModal from "../../../components/ui/popup/ConfirmationModal";

function NewFiling({ allowServices, onNext, filingData }) {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  let allowCreation = searchParams.get("drafts") === null;

  const handleSubmit = (formData) => {
    onNext({ newFiling: formData });
  };

  const handleClose = () => {
    navigate("/");
  };

  const handleConfirm = () => {
    navigate("/tax?status=dra");
  };

  if (allowCreation) {
    return (
      <div>
        <CreateFilingForm
          allowServices={allowServices}
          onSubmit={handleSubmit}
          filingData={filingData}
        />
      </div>
    );
  } else {
    return (
      <Fragment>
        <ConfirmationModal
          isOpen={true}
          onClose={handleClose}
          onConfirm={handleConfirm}
          title="Not Allowed"
          message="Sorry. No more than 5 tax filings are allowed on drafts. Please complete 1 of them and try again!"
          confirmText="Go to Drafts"
          cancelText="Back to Profile"
          confirmButtonClass="primary"
          cancelButtonClass="secondary"
        />
      </Fragment>
    );
  }
}

export default NewFiling;
